import { render, staticRenderFns } from "./UserSetupPage.vue?vue&type=template&id=57471557&scoped=true"
import script from "./UserSetupPage.vue?vue&type=script&lang=js"
export * from "./UserSetupPage.vue?vue&type=script&lang=js"
import style0 from "./UserSetupPage.vue?vue&type=style&index=0&id=57471557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57471557",
  null
  
)

export default component.exports